import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiClient, { IMAGE_BASE_URL } from "../../utils/api-client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  updateProductCategory,
  updateProductCategoryImg,
} from "../../services/userServices";

const UpdateProductCategory = () => {
  const { p_category_id } = useParams();
  const [categoryDetails, setCategoryDetails] = useState([]);
  const [errors, setErrors] = useState("");

  const [categoryImg, setCategoryImg] = useState(null);

  const { register, handleSubmit, setValue } = useForm({
    defaultValues: {
      keywords: categoryDetails.keywords || "",
      meta_title: categoryDetails.meta_title || "",
      meta_description: categoryDetails.meta_description || "",
      p_category_name: categoryDetails.p_category_name || "",
      pcat_title: categoryDetails.pcat_title || "",
      pcat_subtitle: categoryDetails.pcat_subtitle || "",
      pcat_short_desc: categoryDetails.pcat_short_desc || "",
      pcat_long_desc: categoryDetails.pcat_long_desc || "",
      pcat_image: categoryDetails.pcat_image || "0",
      p_category_id: categoryDetails.p_category_id || "0",
    },
  });

  useEffect(() => {
    setValue("keywords", categoryDetails.keywords || "");
    setValue("meta_title", categoryDetails.meta_title || "");
    setValue("meta_description", categoryDetails.meta_description || "");
    setValue("p_category_name", categoryDetails.p_category_name || "");
    setValue("pcat_title", categoryDetails.pcat_title || "");
    setValue("pcat_subtitle", categoryDetails.pcat_subtitle || "");
    setValue("pcat_short_desc", categoryDetails.pcat_short_desc || "");
    setValue("pcat_long_desc", categoryDetails.pcat_long_desc || "");
    setValue("pcat_image", categoryDetails.pcat_image || "");
    setValue("p_category_id", categoryDetails.p_category_id || "");
    setValue("pcat_image", categoryDetails.pcat_image || "");
  }, [categoryDetails]);

  useEffect(() => {
    apiClient
      .get(`/get-single-cate/${p_category_id}`)
      .then((response) => setCategoryDetails(response.data.data))
      .catch((err) => setErrors(err.message));
  }, []);

  const onSubmit = (formData) => {
    updateProductCategory(formData)
      .then((response) => {
        if (response && response.data.status === true) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        toast.error("An error occurred while updating product category.");
      });
  };

  const handleCategoryImgChange = () => {
    updateProductCategoryImg(p_category_id, categoryImg)
      .then((response) => {
        if (response && response.data.status === true) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        toast.error("An error occurred while updating product image.");
      });
  };

  return (
    <>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <form onSubmit={handleSubmit(handleCategoryImgChange)}>
                <div className="card card-dark card-outline">
                  <div className="card-header">
                    <h3 className="card-title">Edit Category Image</h3>
                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i className="fas fa-minus" />
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="col-md-12 border">
                          <div className="row">
                            <div className="col-md-12">
                              <label>Category Image</label>
                              <input
                                className="form-control"
                                type="file"
                                id="upload_image1"
                                name="upload_image1"
                                defaultValue={
                                  categoryDetails && categoryDetails.pcat_image
                                }
                                onChange={(e) =>
                                  setCategoryImg(e.target.files[0])
                                }
                              />
                              <div
                                id="uploaded_image1"
                                className="ml-auto pt-2"
                              />
                              <div className="col-md-12">
                                <div id="previous_image" className="my-3">
                                  <img
                                    src={`${IMAGE_BASE_URL}/${
                                      categoryDetails &&
                                      categoryDetails.pcat_image
                                    }`}
                                    height={100}
                                    className="img-rounded"
                                  />
                                </div>
                              </div>
                              <div
                                className="modal"
                                id="image_modal1"
                                data-backdrop="static"
                                data-keyboard="false"
                                tabIndex={-1}
                                role="dialog"
                              >
                                <div
                                  className="modal-dialog modal-lg"
                                  role="document"
                                >
                                  <div className="modal-content">
                                    <div className="modal-body">
                                      <div className="col-lg-12">
                                        <div id="image_demo1" />
                                      </div>
                                    </div>
                                    <div className="modal-footer">
                                      <button
                                        type="button"
                                        className="btn btn-primary crop_image1"
                                      >
                                        Save and upload
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="float-right">
                      <button
                        type="submit"
                        className="btn btn-dark btn-custom submit"
                      >
                        <i className="fa fa-paper-plane" /> Update
                      </button>
                    </div>
                  </div>
                </div>
              </form>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="card card-dark card-outline">
                  <div className="card-header">
                    <h3 className="card-title">Edit Category</h3>
                    <div className="card-tools">
                      <button
                        type="button"
                        className="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i className="fas fa-minus" />
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="name">Keywords</label>
                          <input
                            type="text"
                            name="keywords"
                            className="form-control"
                            id="keywords"
                            defaultValue={
                              categoryDetails && categoryDetails.keywords
                            }
                            {...register("keywords")}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="category-title">Meta Title</label>
                          <input
                            type="text"
                            id="meta_title"
                            name="meta_title"
                            className="form-control"
                            defaultValue={
                              categoryDetails && categoryDetails.meta_title
                            }
                            {...register("meta_title")}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="category-title">
                            Meta Description
                          </label>
                          <input
                            type="text"
                            id="meta_description"
                            name="meta_description"
                            className="form-control"
                            defaultValue={
                              categoryDetails &&
                              categoryDetails.meta_description
                            }
                            {...register("meta_description")}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>Name</label>
                          <input
                            type="text"
                            name="category"
                            className="form-control"
                            id="category"
                            defaultValue={
                              categoryDetails && categoryDetails.p_category_name
                            }
                            {...register("p_category_name")}
                            required
                          />
                          <input
                            type="hidden"
                            name="category_id"
                            className="form-control"
                            id="category_id"
                            defaultValue={
                              categoryDetails && categoryDetails.p_category_id
                            }
                            required
                            {...register("p_category_id")}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="category-title">Category Title</label>
                          <input
                            type="text"
                            name="cat_title"
                            className="form-control"
                            id="cat_title"
                            defaultValue={
                              categoryDetails && categoryDetails.p_category_name
                            }
                            required
                            {...register("pcat_title")}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="category-title">
                            Category Subtitle
                          </label>
                          <input
                            type="text"
                            name="cat_subtitle"
                            className="form-control"
                            id="cat_subtitle"
                            defaultValue={
                              categoryDetails && categoryDetails.pcat_subtitle
                            }
                            {...register("pcat_subtitle")}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="short-desc">Short Description</label>
                          <textarea
                            name="short_desc"
                            id="short-desc"
                            className="form-control"
                            defaultValue={
                              categoryDetails && categoryDetails.pcat_short_desc
                            }
                            {...register("pcat_short_desc")}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="long-desc">Long Description</label>
                          <textarea
                            name="long_desc"
                            className="form-control"
                            id="long-desc"
                            defaultValue={
                              categoryDetails && categoryDetails.pcat_long_desc
                            }
                            {...register("pcat_long_desc")}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="float-right">
                      <button
                        type="submit"
                        className="btn btn-dark btn-custom submit"
                      >
                        <i className="fa fa-paper-plane" /> Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UpdateProductCategory;
